// Clerk UI localization — maps the app's i18n language to a Clerk locale bundle.
// Keeps Clerk's prebuilt components (SignIn, UserButton, …) in sync with the
// language i18next resolved, so a Ukrainian visitor doesn't land on an English form.

import { enUS, ukUA, ruRU, esES } from '@clerk/localizations';
import type { LocalizationResource } from '@clerk/types';
import type { SupportedLanguage } from '@/i18n/config';

// Each language maps to a single imported bundle, so the reference is stable per
// language — passing it to ClerkProvider's `localization` prop won't trigger
// needless re-renders.
const CLERK_LOCALES: Record<SupportedLanguage, LocalizationResource> = {
  en: enUS,
  uk: ukUA,
  ru: ruRU,
  es: esES,
};

/**
 * Resolve the Clerk locale bundle for an i18n language tag.
 * Strips any region suffix (`uk-UA` → `uk`) and falls back to English.
 */
export function getClerkLocalization(language: string): LocalizationResource {
  const base = (language || 'en').split('-')[0] as SupportedLanguage;
  return CLERK_LOCALES[base] ?? enUS;
}
